import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { motion, AnimatePresence } from 'framer-motion'

import closeImg from '/png/close.png'
import closeGif from '/gif/close.gif'
import message from '@/data/message.json'

import './Subtitles.scss'

export default function Subtitles({ currentIndex, mode }) {
  const dispatch = useDispatch()
  const [isButtonVisible, setIsButtonVisible] = useState(false)
  const [showSubtitles, setShowSubtitles] = useState(false)
  const [isButtonHovered, setIsButtonHovered] = useState(false)

  useEffect(() => {
    document.addEventListener('audioEnd', () => {
      setIsButtonVisible(true)
    })

    // Clean up
    return () => {
      document.removeEventListener('audioEnd', () => {})
    }
  }, [])

  useEffect(() => {
    if (mode !== 'inspection') return
    setShowSubtitles(true)
  }, [mode])

  function onContinueClick() {
    setShowSubtitles(false)

    const event = new Event('closeSubtitles')
    document.dispatchEvent(event)

    setIsButtonVisible(false)
  }

  return (
    <AnimatePresence>
      {showSubtitles && (
        <div className="c-subtitles">
          <div className="c-subtitles__text">
            {message[currentIndex].split(' ').map((word, index) => (
              <motion.span
                style={{
                  display: 'inline-block',
                  margin: '0px 2px',
                  willChange: 'transform, opacity',
                }}
                key={index}
                initial={{ opacity: 0, y: 10 }}
                animate={{
                  opacity: 1,
                  y: 0,
                  transition: {
                    type: 'spring',
                    stiffness: 125,
                    damping: 10,
                    delay: 0.5 + index * 0.05,
                  },
                }}
                exit={{
                  opacity: 0,
                  transition: {
                    duration: 0.5,
                    delay: index * 0.01,
                  },
                }}
              >
                {word}{' '}
              </motion.span>
            ))}
          </div>
          <motion.button
            className={`c-subtitles__close ${
              isButtonVisible ? '-is-visible' : ''
            }`}
            onClick={() => onContinueClick()}
            onPointerEnter={() => setIsButtonHovered(true)}
            onPointerLeave={() => setIsButtonHovered(false)}
            exit={{
              opacity: 0,
              transition: {
                duration: 0.5,
              },
            }}
          >
            <img src={isButtonHovered ? closeGif : closeImg} />
          </motion.button>
        </div>
      )}
    </AnimatePresence>
  )
}
